<template>
  <v-card flat>
    <v-container fluid>
      <v-row>
        <v-card-title class="ml-3 mt-3 pb-0 text-h5 font-weight-bold">{{
          wordList.lbl_delivery_regist
        }}</v-card-title>
      </v-row>
    </v-container>
    <v-card-text>
      <v-container fluid>
        <input
          ref="fileInput"
          type="file"
          accept="text/csv"
          style="display: none"
          @change="onChangeFileUpload"
        />
        <input
          ref="fileInputdelivery"
          type="file"
          accept="text/csv"
          style="display: none"
          @change="onChangeFileUploadDelivery"
        />

        <v-row justify="end">
          <!-- アクションメニュー -->
          <v-menu open-on-hover location="bottom">
            <template #activator="{ props }">
              <v-btn variant="text" color="black" v-bind="props">
                {{ wordList.btn_action }}
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </template>
            <v-list width="280" class="pl-5">
              <!--
              <v-list-item-title
                class="mb-3 mt-3"
                style="cursor: pointer"
                @click="$refs.fileInput.click()"
              >
                <v-icon class="mr-2 mb-1">mdi-cloud-upload</v-icon>
                {{ wordList.lbl_csv_upload_member }}
              </v-list-item-title>
            -->
              <v-list-item-title
                style="cursor: pointer"
                @click="clickFileInputDelivery"
              >
                <v-icon class="mr-2">mdi-cloud-upload</v-icon
                >{{ wordList.lbl_csv_upload_delivery }}
              </v-list-item-title>
              <!--
              <v-divider></v-divider>
              <v-list-item-title class="mb-3 mt-3" style="cursor: pointer">
                <v-icon class="mr-2 mb-1">mdi-cloud-download</v-icon
                >{{ wordList.lbl_temp_download }}
              </v-list-item-title>
              <v-list-item-title class="mb-3" style="cursor: pointer">
                <v-icon class="mr-2 mb-1">mdi-information</v-icon
                >{{ wordList.lbl_temp_explan
                }}<a href="#">{{ wordList.lbl_link_here }}</a>
              </v-list-item-title>
              -->
            </v-list>
          </v-menu>
        </v-row>
        <v-row class="row_eq_height">
          <!-- 新規会員 -->
          <v-col>
            <v-card height="100%" flat border class="mx-auto">
              <v-card-title class="d-flex justify-center mb-4">
                {{ wordList.lbl_first_time_member }}
              </v-card-title>
              <v-card-text>
                <v-row class="justify-center">
                  <!-- tmp_member_registration_flg が OFF の場合（2タブ）: 既存のレイアウトを維持 -->
                  <v-btn-toggle
                    v-model="btnNonMemberToggle"
                    rounded
                    density="compact"
                    color="#2196F3"
                    class="pt-2"
                    v-if="!tmp_member_registration_flg"
                    selected-class="bg-primary text-white border-primary"
                  >
                    <!-- 郵便番号 -->
                    <v-btn
                      :value="0"
                      class="pl-10 pr-10"
                      variant="outlined"
                      color="grey-lighten-1"
                      @click="onClickToggleZip"
                      >{{ wordList.lbl_zipcode }}</v-btn
                    >
                    <!-- 都道府県 -->
                    <v-btn
                      :value="1"
                      class="pl-10 pr-10"
                      variant="outlined"
                      color="grey-lighten-1"
                      @click="onClickTogglePref"
                      >{{ wordList.lbl_prefectures }}</v-btn
                    >
                  </v-btn-toggle>
                  <!-- tmp_member_registration_flg が ON の場合（3タブ）: PC用（sm以上） -->
                  <v-btn-toggle
                    v-model="btnNonMemberToggle"
                    rounded
                    density="compact"
                    color="#2196F3"
                    class="pt-2 d-none d-sm-inline-flex"
                    v-if="tmp_member_registration_flg"
                    selected-class="bg-primary text-white border-primary"
                  >
                    <!-- 郵便番号 -->
                    <v-btn
                      :value="0"
                      class="pl-10 pr-10"
                      variant="outlined"
                      color="grey-lighten-1"
                      @click="onClickToggleZip"
                      >{{ wordList.lbl_zipcode }}</v-btn
                    >
                    <!-- 都道府県 -->
                    <v-btn
                      :value="1"
                      class="pl-10 pr-10"
                      variant="outlined"
                      color="grey-lighten-1"
                      @click="onClickTogglePref"
                      >{{ wordList.lbl_prefectures }}</v-btn
                    >
                    <!-- 仮会員一覧 -->
                    <v-btn
                      :value="2"
                      class="pl-10 pr-10"
                      variant="outlined"
                      color="grey-lighten-1"
                      @click="onClickTmpMemberList"
                      >{{ wordList.btn_open_tmp_member_list }}</v-btn
                    >
                  </v-btn-toggle>
                  <!-- tmp_member_registration_flg が ON の場合（3タブ）: モバイル用（xs のみ） -->
                  <v-btn-toggle
                    v-model="btnNonMemberToggle"
                    rounded
                    dense
                    color="#2196F3"
                    class="pt-2 d-inline-flex d-sm-none"
                    v-if="tmp_member_registration_flg"
                    selected-class="bg-primary text-white border-primary"
                  >
                    <!-- 郵便番号 -->
                    <v-btn
                      :value="0"
                      class="px-2"
                      variant="outlined"
                      color="grey-lighten-1"
                      @click="onClickToggleZip"
                      >{{ wordList.lbl_zipcode }}</v-btn
                    >
                    <!-- 都道府県 -->
                    <v-btn
                      :value="1"
                      class="px-2"
                      variant="outlined"
                      color="grey-lighten-1"
                      @click="onClickTogglePref"
                      >{{ wordList.lbl_prefectures }}</v-btn
                    >
                    <!-- 仮会員一覧 -->
                    <v-btn
                      :value="2"
                      class="px-2"
                      variant="outlined"
                      color="grey-lighten-1"
                      @click="onClickTmpMemberList"
                      >{{ wordList.btn_open_tmp_member_list }}</v-btn
                    >
                  </v-btn-toggle>
                </v-row>
                <v-row v-if="btnNonMemberToggle == 0">
                  <v-col align-self="center">
                    <!-- 郵便番号 -->
                    <Field
                      v-slot="{ field, errors }"
                      name="zip_code"
                      :label="wordList.lbl_zipcode"
                      rules="required|numeric|length:7"
                    >
                      <v-text-field
                        :model-value="field.value ?? zip_code"
                        class="mx-auto"
                        :placeholder="wordList.plc_zipcode"
                        density="compact"
                        variant="outlined"
                        :hint="wordList.lbl_no_hyphen"
                        persistent-hint
                        :disabled="isReceiptBarcodeFocusing"
                        :error-messages="
                          errorZipCode
                            ? [...errors, errorZipCode]
                            : errors
                        "
                        style="width: 80%"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            zip_code = String(val ?? '');
                            onZipCodeInput();
                          }
                        "
                        @blur="() => field.onBlur()"
                      ></v-text-field>
                    </Field>
                  </v-col>
                </v-row>
                <v-row v-if="btnNonMemberToggle == 1">
                  <v-col align-self="center">
                    <!-- 都道府県 -->
                    <v-autocomplete
                      v-model="prefSelectValue"
                      class="mx-auto"
                      density="compact"
                      :items="prefListItems"
                      item-title="name"
                      item-value="pref_name"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      :disabled="isReceiptBarcodeFocusing"
                      style="width: 80%"
                      @update:model-value="onPrefSelectInput"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="errorPrefSelect && btnNonMemberToggle == 1" dense>
                  <v-col>
                    <v-card-text
                      class="text-red px-0 py-0 mx-auto"
                      style="width: 80%"
                    >
                      {{ errorPrefSelect }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-center pb-8">
                <v-btn
                  variant="flat"
                  :disabled="isNewMemberButtonDisabled || isReceiptBarcodeFocusing"
                  color="primary"
                  class="px-16 mb-3 new-member-register-btn"
                  @click="onClickDeliveryRequestAndNewMember"
                >
                  <v-icon>mdi-playlist-edit</v-icon>
                  {{ wordList.btn_delivery_regits_member }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <!-- 既存会員 -->
          <v-col>
            <v-card flat border class="mx-auto">
              <v-card-title class="d-flex justify-center mb-4">
                {{ wordList.lbl_registered_member }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col class="pb-2" align-self="center">
                    <Field
                      v-slot="{ componentField, errors }"
                      v-model="phone_number"
                      name="tel4"
                      :label="wordList.lbl_tel4"
                      rules="numeric|length:4"
                    >
                      <v-text-field
                        v-bind="componentField"
                        class="mx-auto"
                        :label="wordList.lbl_tel4"
                        variant="outlined"
                        density="compact"
                        persistent-placeholder
                        :disabled="isReceiptBarcodeFocusing"
                        :placeholder="wordList.lbl_tel4"
                        :error-messages="errors"
                        style="width: 80%"
                      ></v-text-field>
                    </Field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col align-self="center" class="py-0">
                    <v-text-field
                      v-model="user_name"
                      class="mx-auto"
                      :label="wordList.lbl_name_kana"
                      variant="outlined"
                      density="compact"
                      persistent-placeholder
                      :disabled="isReceiptBarcodeFocusing"
                      :placeholder="wordList.plc_name"
                      style="width: 80%"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="house_card_display == 1">
                  <v-col align-self="center" class="py-0">
                    <v-text-field
                      v-model="house_card"
                      class="mx-auto"
                      :label="wordList.lbl_house_card"
                      variant="outlined"
                      density="compact"
                      persistent-placeholder
                      :disabled="isReceiptBarcodeFocusing"
                      :placeholder="wordList.plc_house_card"
                      style="width: 80%"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="use_receipt_barcode_search_flg == 1">
                  <v-col class="py-0">
                    <!-- バーコードリーダー入力を想定し、数字入力用のキーボードを出しやすくする -->
                    <v-text-field
                      :label="wordList.lbl_receipt_barcode"
                      ref="receipt_barcode_input"
                      :maxlength="16"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      variant="outlined"
                      density="compact"
                      :model-value="receipt_barcode"
                      class="mx-auto"
                      persistent-placeholder
                      :placeholder="wordList.plc_receipt_barcode"
                      style="width: 80%"
                      @keydown="onReceiptBarcodeKeyDown"
                      @update:model-value="onReceiptBarcodeUpdate"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense v-if="userErrorMessage">
                  <v-col class="py-0">
                    <v-card-text
                      class="text-red px-0 py-0 mx-auto"
                      style="width: 80%"
                    >
                      {{ userErrorMessage }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  variant="flat"
                  color="primary"
                  class="px-16 mb-3"
                  :disabled="btnDisabled || isReceiptBarcodeFocusing"
                  @click="onClickDeliveryRequest"
                >
                  <v-icon>mdi-magnify</v-icon>
                  {{ wordList.btn_delivery_regist }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- エリア空き状況 -->
        <v-row>
          <v-col cols="12">
            <v-card flat border>
              <v-card-title class="justify-center align-center">
                <p class="justify-center my-2 mr-2">
                  {{ wordList.btn_area_select }}
                </p>
                <div class="my-2">
                  <Field
                    v-slot="{ errors }"
                    name="area_name"
                    :label="wordList.lbl_area_name"
                    rules="max:100"
                  >
                    <v-autocomplete
                      v-model="areaSelectValues"
                      density="compact"
                      hide-details
                      :items="areaListItems"
                      item-title="area_name"
                      item-value="area_code"
                      :label="wordList.lbl_area_name"
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      :error-messages="errors"
                      return-object
                      variant="outlined"
                      @update:model-value="onChangeArea"
                    ></v-autocomplete>
                  </Field>
                </div>
              </v-card-title>

              <div v-if="deliveryAvailabilityData.length > 0" id="wrap">
                <div class="d-flex mb-10 overflow-x-auto mx-4">
                  <div>
                    <div class="list_item_blank"></div>
                    <ul class="list_area br_b_1">
                      <li
                        v-for="[delivery_id_desc] in deliveryAvailabilityHeader"
                        :key="delivery_id_desc"
                        class="list_item_time"
                      >
                        {{ delivery_id_desc }}
                      </li>
                    </ul>
                  </div>

                  <div class="d-flex overflow-scrollr br_b_1">
                    <div
                      v-for="cols in deliveryAvailabilityData"
                      :key="cols.delivery_data"
                    >
                      <ul
                        v-for="delivery_data in cols"
                        :key="delivery_data.delivery_date + delivery_data.key"
                        class="list_area list_area_item"
                      >
                        <li
                          v-if="delivery_data.key == 1"
                          class="list_item list_item_day"
                        >
                          <div>
                            <p class="mb-0">
                              {{ formatDate(delivery_data.delivery_date) }}
                            </p>
                          </div>
                        </li>
                        <li class="list_item list_item_btn">
                          <a
                            class="cursor_pointer btn_select_del"
                            :class="
                              delivery_data.availability == '×'
                                ? 'btn-receive-disable'
                                : 'btn-receive'
                            "
                            @click="
                              onDeliveryAvailabilityClick(
                                delivery_data.delivery_date,
                                String(delivery_data.delivery_id)
                              )
                            "
                          >
                            <!--<i :class="getClass(delivery_data.availability)"></i>-->
                            <i
                              v-if="delivery_data.availability == '○'"
                              class="circle_receive"
                            ></i>
                            <i
                              v-else-if="
                                delivery_data.availability == '△' ||
                                delivery_data.availability == '▲'
                              "
                              class="triangle_receive"
                            ></i>
                            <i
                              v-else-if="
                                delivery_data.availability == '×' ||
                                delivery_data.availability == '0'
                              "
                              class="batsu_receive"
                            ></i>
                            <div
                              v-else
                              class="text_16px font-weight-bold color_primary"
                            >
                              {{ delivery_data.availability }}
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <!-- 会員登録情報確認ダイアログ {-->
    <v-dialog v-model="dialog" width="80%" scrollable>
      <v-data-iterator
        :items="listMemberResult"
        :items-per-page="listMemberResult.length"
        item-key="name"
        hide-default-footer
        :server-items-length="50"
      >
        <template #default="{ items }">
          <v-card>
            <v-card-title class="bg-primary mb-5" style="color: white">{{
              wordList.lbl_member_confirm
            }}</v-card-title>
            <v-card-text class="font-weight-black"
              >{{ wordList.lbl_hit_member_info }} {{ listMemberResult.length }}
              {{ wordList.lbl_exist_number }}</v-card-text
            >
            <v-card-text style="max-height: 60vh; overflow-y: auto;">
              <v-card
                v-for="item in items"
                :key="item.raw?.member_id ?? item.key"
                class="mb-5"
              >
                <v-card-title class="py-2">
                  <h5>
                    {{ wordList.lbl_member_id }} : {{ item.raw?.member_id }}
                  </h5>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row dense>
                    <v-col
                      cols="5"
                      sm="2"
                      md="2"
                      lg="2"
                      class="font-weight-black"
                      >{{ wordList.lbl_member_id }} :
                    </v-col>
                    <v-col>
                      {{ item.raw?.member_id }}
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col
                      cols="5"
                      sm="2"
                      md="2"
                      lg="2"
                      class="font-weight-black"
                      >{{ wordList.lbl_name }} :
                    </v-col>
                    <v-col>
                      {{ item.raw?.name_kana1 }} {{ item.raw?.name_kana2 }}
                      {{ wordList.lbl_sama }}
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col
                      cols="5"
                      sm="2"
                      md="2"
                      lg="2"
                      class="font-weight-black"
                      >{{ wordList.lbl_tel }} :
                    </v-col>
                    <v-col cols="7">
                      {{ item.raw?.phone }}
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col
                      cols="5"
                      sm="2"
                      md="2"
                      lg="2"
                      class="font-weight-black"
                      >{{ wordList.lbl_address }} :
                    </v-col>
                    <v-col cols="7">
                      {{ item.raw?.address1 }}{{ item.raw?.address2
                      }}{{ item.raw?.address3 }}
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-center pb-3">
                  <v-btn
                    variant="flat"
                    :disabled="item.raw?.is_deliverable === 0"
                    color="primary"
                    class="btn_width_2 mb-1"
                    @click="onClickDeliveryRequestByUser(item.raw)"
                  >
                    <v-icon>mdi-playlist-edit</v-icon>
                    <span v-if="item.raw?.is_deliverable === 0">
                      {{ wordList.lbl_not_deliverable }}
                    </span>
                    <span v-else>
                      {{ wordList.btn_select_member_regist }}
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
              <!-- 戻るボタン -->
              <div class="d-flex justify-center">
                <v-btn
                  variant="flat"
                  color="return"
                  class="btn_width_1 my-3"
                  @click="dialog = false"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                  {{ wordList.btn_return }}</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </template>
      </v-data-iterator>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>
    <!-- } 会員登録情報確認ダイアログ -->
    <!-- { ダイアログ -->
    <AlertDialog
      v-model="messagedialog"
      :title="wordList.lbl_delivery_regist"
      :message="message"
      type="info"
    />
    <!-- } ダイアログ -->
    <!-- アップロード中 ダイアログ { -->
    <v-dialog v-model="uploadDialog" persistent width="40%">
      <v-card>
        <v-card-title>アップロード</v-card-title>
        <v-card-text>
          <v-container style="height: 200px">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                アップロード中...
              </v-col>
              <v-col cols="6">
                <v-progress-linear
                  color="deep-purple-accent-4"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- } アップロード中 ダイアログ -->
  </v-card>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Field, defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { required, max, length, alpha_dash, numeric } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import { useRouter } from "vue-router";
import AlertDialog from "@/components/AlertDialog.vue";
import { useDeliveryRequestRegisterStartState } from "./composables/useDeliveryRequestRegisterStartState";
import { useDeliveryRequestRegisterStartDelivery } from "./composables/useDeliveryRequestRegisterStartDelivery";
import { useDeliveryRequestRegisterStartMember } from "./composables/useDeliveryRequestRegisterStartMember";
import { useDeliveryRequestRegisterStartUpload } from "./composables/useDeliveryRequestRegisterStartUpload";
import { useDeliveryRequestRegisterStartInit } from "./composables/useDeliveryRequestRegisterStartInit";

defineRule("required", required);
defineRule("max", max);
defineRule("length", length);
defineRule("alpha_dash", alpha_dash);
defineRule("numeric", numeric);
configure({
  generateMessage: localize({ ja }),
});

// 画面で使用する状態を composable から集約する
const router = useRouter();
const state = useDeliveryRequestRegisterStartState();

const {
  btnNonMemberToggle,
  prefSelectValue,
  phone_number,
  user_name,
  house_card,
  userErrorMessage,
  zip_code,
  errorZipCode,
  errorPrefSelect,
  wordList,
  dialog,
  overlay,
  messagedialog,
  message,
  uploadDialog,
  btnDisabled,
  getAvailableDate,
  prefListItems,
  listMemberResult,
  memberData,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  deliveryAvailabilityStore,
  areaListItems,
  areaSelectValues,
  house_card_display,
  is_hide_other_shop_members,
  tmp_member_registration_flg,
  use_receipt_barcode_search_flg,
  isReceiptBarcodeFocusing,
  receipt_barcode,
  receipt_barcode_house_card,
  register_no,
  receipt_no,
  payment_amount,
  fileInput,
  fileInputdelivery,
  receipt_barcode_input,
} = state;

const { formatDate, showDeliveryAvailability, getDeliveryAvailable } =
  useDeliveryRequestRegisterStartDelivery({
    deliveryAvailabilityData,
    deliveryAvailabilityHeader,
    areaSelectValues,
    deliveryAvailabilityStore,
    getAvailableDate,
    btnDisabled,
  });

// 会員検索・遷移関連の操作を composable から取得
const {
  onClickToggleZip,
  onClickTogglePref,
  onChangeArea,
  onZipCodeInput,
  onPrefSelectInput,
  onClickTmpMemberList,
  onClickDeliveryRequestAndNewMember,
  onClickDeliveryRequest,
  onClickDeliveryRequestByUser,
} = useDeliveryRequestRegisterStartMember({
  router,
  btnNonMemberToggle,
  zip_code,
  prefSelectValue,
  errorZipCode,
  errorPrefSelect,
  userErrorMessage,
  getAvailableDate,
  deliveryAvailabilityStore,
  wordList,
  house_card_display,
  phone_number,
  user_name,
  house_card,
  receipt_barcode,
  receipt_barcode_house_card,
  register_no,
  receipt_no,
  payment_amount,
  is_hide_other_shop_members,
  listMemberResult,
  memberData,
  dialog,
  message,
  showDeliveryAvailability,
});

// CSVアップロード関連の操作を composable から取得
const { onChangeFileUpload, onChangeFileUploadDelivery, clickFileInputDelivery } =
  useDeliveryRequestRegisterStartUpload({
    overlay,
    messagedialog,
    message,
    uploadDialog,
    fileInput,
    fileInputdelivery,
  });

const hasSelectedPref = computed(() => {
  if (typeof prefSelectValue.value === "string") {
    return prefSelectValue.value.trim().length > 0;
  }
  return (
    prefSelectValue.value !== null &&
    prefSelectValue.value !== undefined &&
    prefSelectValue.value !== ""
  );
});

const isNewMemberButtonDisabled = computed(() => {
  if (btnDisabled.value) {
    return true;
  }

  if (btnNonMemberToggle.value === 0) {
    // 郵便番号タブ: フォーマットエラー or 対象外エラーがある間は操作させない。
    const zipHasRuleError = !/^\d{7}$/.test(zip_code.value);
    return zipHasRuleError || !!errorZipCode.value;
  }

  if (btnNonMemberToggle.value === 1) {
    // 都道府県タブ: 未選択またはエラー時は操作不可。
    return !hasSelectedPref.value || !!errorPrefSelect.value;
  }

  // 仮会員一覧タブでは「配送依頼・会員登録」は無効化する。
  return true;
});

// 初期表示処理と各種 watch を登録
const { onReceiptBarcodeUpdate, onReceiptBarcodeKeyDown } =
  useDeliveryRequestRegisterStartInit({
  wordList,
  house_card_display,
  is_hide_other_shop_members,
  use_receipt_barcode_search_flg,
  isReceiptBarcodeFocusing,
  prefListItems,
  areaListItems,
  receipt_barcode_input,
  receipt_barcode,
  dialog,
  receipt_barcode_house_card,
  register_no,
  receipt_no,
  payment_amount,
  showDeliveryAvailability,
  getDeliveryAvailable,
  onClickDeliveryRequest,
  });

/**
 * 空き状況クリック時のデバッグログを出力する。
 */
function onDeliveryAvailabilityClick(date: string, deliveryid: string): void {
  console.log(date + "/" + deliveryid);
}
</script>

<style scoped>
:deep(.new-member-register-btn.v-btn--disabled) {
  /* disabled のまま見た目のみ活性状態を維持する。 */
  --v-disabled-opacity: 1;
  background: rgb(var(--v-theme-primary)) !important;
  color: rgb(var(--v-theme-on-primary)) !important;
  pointer-events: auto !important;
  cursor: not-allowed !important;
  user-select: none !important;
}

:deep(.new-member-register-btn.v-btn--disabled .v-btn__overlay) {
  opacity: 0 !important;
}
</style>
